import { z } from 'zod';
import { TemplateCornSchema } from '../corn.js';
export const GetTemplateDocumentUrlApiSchema = {
    params: z.object({
        id: TemplateCornSchema,
    }),
    response: z.object({
        url: z.string(),
    }),
};
export const GetTemplateDocumentUrlRequestSchema = GetTemplateDocumentUrlApiSchema.params;
